import Toast, { ToastProps } from "@ingka/toast";
import { createContext, ReactNode, useCallback, useState } from "react";

type ToastContent = ToastProps["text"];

type ToastContextType = {
  toast: (content: ToastContent) => void;
};

export const ToastContext = createContext<ToastContextType | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [visible, setVisible] = useState(false);
  const [toastContent, setToastContent] = useState<ToastContent>("");

  const toast = useCallback((content: ToastContent) => {
    setToastContent(content);
    setVisible(true);
  }, []);

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <Toast
        text={toastContent}
        isOpen={visible}
        onCloseRequest={() => setVisible(false)}
      />
    </ToastContext.Provider>
  );
}
